import { TagFilter, VisitFilter } from 'gql-types';

/**
 * Combine a dashboard variation's optional "Today's Visits" filter with the
 * active tag filter into the single VisitFilter applied to the homepage
 * Today's Visits query.
 *
 * Handling rules:
 *   - Both present  → the tag filter is AND'd onto the variation filter.
 *   - One present   → it is used as-is.
 *   - Neither       → null, so the query is left unfiltered (no per-variation
 *                     filter leaks into orgs that don't configure one).
 *
 * The function is config-agnostic: it never references any specific variation's
 * filter values — it only describes how an arbitrary configured filter is
 * applied.
 */
export function buildAppliedVisitFilter(
    variationFilter: VisitFilter | null | undefined,
    tagFilter: TagFilter | null,
): VisitFilter | null {
    const tagFilterClause: VisitFilter | null = tagFilter
        ? { patient: { hasTag: tagFilter } }
        : null;
    const normalizedVariationFilter = variationFilter ?? null;

    if (tagFilterClause && normalizedVariationFilter) {
        return { ...normalizedVariationFilter, AND: tagFilterClause };
    }
    return tagFilterClause ?? normalizedVariationFilter;
}
